import * as React from 'react';

import PropTypes from 'prop-types';
// @mui
import { Box, Typography, Link } from '@mui/material';
//
import Breadcrumbs from './Breadcrumbs';
import MDSubtitleText from './ui/typography/MDSubtitleText';

// ----------------------------------------------------------------------

HeaderBreadcrumbs.propTypes = {
  links: PropTypes.array,
  action: PropTypes.node,
  heading: PropTypes.string.isRequired,
  moreLink: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  sx: PropTypes.object,
  subtitleClass: PropTypes.string,
  titleContainerClass: PropTypes.string
};

export default function HeaderBreadcrumbs({
  links,
  action,
  heading,
  subtitleClass = 'mb-2',
  titleContainerClass,
  moreLink = '' || [],
  sx,
  ...other
}) {
  return (
    <Box sx={{ mb: [3, 4, 4], ...sx }}>
      <Box sx={{ display: 'flex', alignItems: 'center', ...titleContainerClass }}>
        <Box sx={{ flexGrow: 1 }}>
          <MDSubtitleText title={heading} fontWeight="text-bold" className={`${subtitleClass}`} />
          <Breadcrumbs links={links} {...other} />
        </Box>

        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Box>

      <Box sx={{ mt: 2 }}>
        {typeof moreLink === 'string' ? (
          <Link href={moreLink} target="_blank" rel="noopener" variant="body2">
            {moreLink}
          </Link>
        ) : (
          moreLink.map((href) => (
            <Link
              noWrap
              key={href}
              href={href}
              variant="body2"
              target="_blank"
              rel="noopener"
              sx={{ display: 'table' }}
            >
              {href}
            </Link>
          ))
        )}
      </Box>
    </Box>
  );
}
